import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getReminderFlow = asyncThunkWrapper({ 
  model: 'reminderFlow', 
  action: 'getReminderFlow', 
  func: async () => {
    const attributes = ['id', 'before_in', 'send_at', 'time_zone', 'text_translations', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/reminder_flow`, { params });

    return response.data;
  } 
});
export const createReminderFlow = asyncThunkWrapper({ 
  model: 'reminderFlow', 
  action: 'createReminderFlow', 
  func: async (reminder_flow) => {
    const attributes = ['id', 'before_in', 'send_at', 'text_translations', 'updated_at'];
    const response = await axios.post(`/reminder_flow`, { reminder_flow, attributes });

    return response.data;
  } 
});
export const updateReminderFlow = asyncThunkWrapper({ 
  model: 'reminderFlows', 
  action: 'updateReminderFlow', 
  func: async (reminder_flow) => {
    const response = await axios.patch(`/reminder_flow`, { reminder_flow });

    return { status: response.status, reminder_flow };
  } 
});
export const deleteReminderFlow = asyncThunkWrapper({ 
  model: 'reminderFlow', 
  action: 'deleteReminderFlow', 
  func: async () => {
    const response = await axios.delete(`/reminder_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveReminderFlow = createAction('reminderFlow/clearLocalActiveReminderFlow');